/* eslint-disable */
import React, { useEffect } from "react";
import { getSharedManagementInvitations } from "../../../actions/appExpandedActions/properties";
import { connect } from "react-redux";
import DataTable from "../DataTable";
import { tablePresets } from "../DataTable/tablePresets";

const SharedManagementInvitations = ({ getSharedManagementInvitations, sharedManagementInvitations, period }) => {
  // Initial load
  useEffect(() => {
    getSharedManagementInvitations({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getSharedManagementInvitations(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    // Use the same logic for load more
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getSharedManagementInvitations(payload);
  };

  return (
    <DataTable
      {...tablePresets.sharedManagementInvitations}
      data={sharedManagementInvitations}
      fetchData={getSharedManagementInvitations}
      period={period}
      onLoadMore={handleLoadMore}
    />
  );
};

const mapStateToProps = (state) => ({
  sharedManagementInvitations: state.appProperties.sharedManagementInvitations,
});

const mapDispatchToProps = (dispatch) => ({
  getSharedManagementInvitations: (payload) => dispatch(getSharedManagementInvitations(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SharedManagementInvitations);
